import { render, staticRenderFns } from "./NormComputeSet.vue?vue&type=template&id=1e23d2eb&scoped=true"
import script from "./NormComputeSet.vue?vue&type=script&lang=js"
export * from "./NormComputeSet.vue?vue&type=script&lang=js"
import style0 from "./NormComputeSet.vue?vue&type=style&index=0&id=1e23d2eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23d2eb",
  null
  
)

export default component.exports